import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import {
  mdiAccount,
  mdiAccountBox,
  mdiAccountCircle,
  mdiAccountEditOutline,
  mdiArrowLeft,
  mdiArrowRight,
  mdiArrowUp,
  mdiCalendar,
  mdiCancel,
  mdiCheck,
  mdiCheckDecagram,
  mdiCheckDecagramOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarked,
  mdiCheckboxMarkedCircle,
  mdiCheckboxMarkedCircleOutline,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircleSmall,
  mdiClipboardOutline,
  mdiClose,
  mdiCloseCircle,
  mdiCloseCircleOutline,
  mdiContentSave,
  mdiDelete,
  mdiDownload,
  mdiExitToApp,
  mdiEye,
  mdiEyeOff,
  mdiFileDocumentArrowRightOutline,
  mdiFileExcelBoxOutline,
  mdiFilePdfBox,
  mdiFileWordBoxOutline,
  mdiFolder,
  mdiHome,
  mdiInformationOutline,
  mdiLoading,
  mdiMenu,
  mdiMenuDown,
  mdiMinus,
  mdiPencil,
  mdiPlay,
  mdiPlus,
  mdiQuestion,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
  mdiRestore,
  mdiSend,
  mdiStar,
  mdiStarHalfFull,
  mdiStop,
  mdiSubdirectoryArrowRight,
  mdiSortAlphabeticalAscending,
  mdiSortAlphabeticalDescending,
  mdiViewDashboardOutline,
  mdiLogout,
  mdiBagPersonal,
  mdiMagnify,
  mdiTextBoxSearch,
  mdiTextBoxSearchOutline,
  mdiWarning,
  mdiAlertCircle,
  mdiPageFirst,
  mdiPageLast,
} from "@mdi/js";

// Usage: <v-icon>$restore</v-icon> or this.$vuetify.icons.restore
const MY_ICONS = {
  /* jm custom */
  wordIcon: mdiFileWordBoxOutline,
  excelIcon: mdiFileExcelBoxOutline,
  pdfIcon: mdiFilePdfBox,
  docIcon: mdiFileDocumentArrowRightOutline,
  folder: mdiFolder,
  sortAZ: mdiSortAlphabeticalAscending,
  sortZA: mdiSortAlphabeticalDescending,
  plus: mdiPlus,
  cancel1: mdiCloseCircleOutline,
  save: mdiContentSave,
  stop: mdiStop,
  loop: mdiRestore,
  restore: mdiRestore,
  play: mdiPlay,
  chevup: mdiChevronUp,
  chevdown: mdiChevronDown,
  person: mdiAccountCircle,
  person2: mdiBagPersonal,
  home: mdiHome,
  checkedcircle: mdiCheckboxMarkedCircle,

  /* default-ish aliases Vuetify may look for */
  eye: mdiEye,
  eyeoff: mdiEyeOff,
  complete: mdiCheck,
  cancel: mdiCancel,
  close: mdiClose,
  delete: mdiCloseCircle, // chip close / soft delete icon usage
  del: mdiDelete, // your explicit trash/delete usage
  clear: mdiClose,
  success: mdiCheck,
  successOutline: mdiCheckDecagramOutline,
  successBold: mdiCheckDecagram,
  info: mdiInformationOutline,
  warning: mdiWarning,
  error: mdiAlertCircle,
  prev: mdiChevronLeft,
  next: mdiChevronRight,
  checkboxOn: mdiCheckboxMarked,
  checkboxOff: mdiCheckboxBlankOutline,
  checkboxIndeterminate: mdiMinus,
  delimiter: mdiCircleSmall,
  sort: mdiArrowUp,
  expand: mdiMenuDown,
  menu: mdiMenu,
  subgroup: mdiSubdirectoryArrowRight,
  dropdown: mdiMenuDown,
  radioOn: mdiRadioboxMarked,
  radioOff: mdiRadioboxBlank,
  edit: mdiPencil,
  ratingEmpty: mdiStar,
  ratingFull: mdiStar,
  ratingHalf: mdiStarHalfFull,
  loading: mdiLoading,
  first: mdiPageFirst,
  last: mdiPageLast,
  unfold: mdiMenuDown,
  file: mdiFileDocumentArrowRightOutline,

  /* additional icons already used in project */
  arrowLeft: mdiArrowLeft,
  arrowRight: mdiArrowRight,
  send: mdiSend,
  checkboxMarkedOutline: mdiCheckboxMarkedCircleOutline,
  magnify: mdiMagnify,
  search: mdiMagnify,
  appViewDash: mdiViewDashboardOutline,
  accountEdit: mdiAccountEditOutline,
  logout: mdiLogout,
  account: mdiAccount,
  accountBox: mdiAccountBox,
  textSearch: mdiTextBoxSearch,
  textSearchOutline: mdiTextBoxSearchOutline,
  exitToApp: mdiExitToApp,
  clipboard: mdiClipboardOutline,
  dl: mdiDownload,
  help: mdiQuestion,
  star: mdiStar,
  calendar: mdiCalendar,
};

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: MY_ICONS,
  },

  theme: {
    dark: true,
    themes: {
      light: {
        background: "#172815",
        primary: "#283a44",
        secondary: "#C8D5B9",
        accent: "#CCB159",
        accent2: "#708e92",
        error: "#f44336",
        warning: "#ff9800",
        info: "#03a9f4",
        success: "#4caf50",
        cmpbk: "#172815",
        navbk: "#2c3e50",
        appbck: "#ffa500",
        darkcmpbk: "#21262d",
        lightergrey: "#3C4047",
        greenbtn: "#22f1bf",
      },
      dark: {
        appbck: "#ffa500",
        darkcmpbk: "#21262d",
        lightergrey: "#3C4047",
        redbtn: "#f44336",
        redbtnback: "#32282D",
        greenbtn: "#22f1bf",
        greenbtnhover: "#1FDEB0",
        greenbtnactive: "#1AB791",
        inputbck: "#464B52",
        primary: "#21262d",
        secondary: "#363C43",
      },
    },
    options: {
      customProperties: true,
    },
  },
});